export const OFFER_SALE_TERMS_BODY = `1. DEFINITIONS
1.1 "Euroasiann"
"Euroasiann" means Euroasiann Marine Spares Pvt. Ltd., including its permitted Affiliates, representatives, employees, contractors, and service providers acting in connection with the relevant transaction.

1.2 "Buyer"
"Buyer" means the legal entity identified on the relevant Offer, quotation, sales order, purchase order, proforma invoice, invoice, or order confirmation.

1.3 "Supplier"
"Supplier" means the manufacturer, distributor, dealer, stockist, trader, reseller, OEM, aftermarket supplier, or other third party from whom Euroasiann sources or procures the Goods.

1.4 "Offer"
"Offer" means the commercial offer issued by Euroasiann identifying the Goods, quantities, prices, currency, delivery terms, validity, and other transaction-specific conditions.

1.5 "Goods"
"Goods" means the marine spare parts, equipment, components, consumables, materials, or other physical products expressly identified in the Offer.

1.6 "Transaction"
"Transaction" means the sale and purchase of Goods between Euroasiann and the Buyer arising from an accepted Offer.

1.7 "Delivery Location"
"Delivery Location" means the location expressly stated in the Offer or subsequently agreed in writing.

1.8 "Business Day"
"Business Day" means a day on which commercial banks are generally open for business in the jurisdiction applicable to the relevant Transaction.

2. COMMERCIAL NATURE OF THE TRANSACTION
2.1 Principal-to-Principal Sale
Unless expressly stated otherwise in writing, Euroasiann sells the Goods to the Buyer as a principal and not merely as an agent, broker, freight forwarder, customs broker, manufacturer, or intermediary.

2.2 Separate Purchase and Resale
Euroasiann may source Goods from one or more Suppliers and resell those Goods to the Buyer.

The Buyer's purchase contract is with Euroasiann. The Supplier's contractual relationship with Euroasiann is separate from the Buyer's contractual relationship with Euroasiann.

2.3 No Direct Supplier Contract
The Buyer acknowledges that the identity of a Supplier, manufacturer, distributor, stockist, or other source does not by itself create a contractual relationship between that party and the Buyer.

2.4 No Supplier Obligations Assumed by Buyer
The Buyer shall not rely on any separate Supplier terms unless those terms have been expressly incorporated into the Offer or Transaction.

2.5 Euroasiann's Procurement Structure
Euroasiann may source Goods specifically after receiving the Buyer's order or acceptance of an Offer.

Accordingly, the Goods may not be physically held by Euroasiann at the time the Offer is issued.

3. OFFER AND ACCEPTANCE
3.1 Offer Validity
Each Offer shall remain valid only for the validity period expressly stated in the Offer.

If no validity period is stated, the Offer may be withdrawn or amended by Euroasiann before acceptance.

3.2 Acceptance
The Buyer's acceptance may occur through:

electronic acceptance;

clicking an acceptance button;

issuing a purchase order;

written confirmation;

payment;

partial payment;

or another action clearly indicating acceptance.

3.3 Binding Transaction
Once an Offer has been validly accepted by the Buyer and Euroasiann has confirmed the Transaction, the relevant commercial terms become binding, subject to these Sale Terms.

3.4 No Acceptance by Silence
Silence alone shall not constitute acceptance unless Applicable Law provides otherwise or the parties have expressly agreed otherwise.

3.5 Electronic Acceptance
Electronic acceptance shall have the same contractual significance as written acceptance to the maximum extent permitted by Applicable Law.

3.6 Offer Expiration
An expired Offer does not create an obligation on Euroasiann to supply the Goods at the expired price or conditions.

4. DESCRIPTION OF GOODS
4.1 Offer Description
The Goods shall be identified in the Offer by available commercial and technical information, which may include:

Part Number;

Manufacturer;

Brand;

Model;

Type;

Description;

Quantity;

Unit of Measure;

Country of Origin;

Condition;

Availability;

Delivery Location;

and other relevant information.

4.2 Buyer Responsibility for Specifications
The Buyer is responsible for ensuring that the specifications, Part Numbers, equipment information, Vessel information, model information, serial numbers, dimensions, drawings, and other technical information supplied by the Buyer are accurate and complete.

4.3 Buyer Technical Verification
The Buyer shall independently verify that the Goods are suitable for the intended Vessel, machinery, equipment, installation, operating environment, regulatory requirements, and intended application unless Euroasiann has expressly undertaken a separate written technical verification obligation.

4.4 Part Number
Where a Part Number is specified, the Buyer shall verify the Part Number before accepting the Offer.

4.5 Equivalent or Alternative Goods
Euroasiann shall not supply an alternative, equivalent, aftermarket, refurbished, reconditioned, or substituted Product unless such alternative is expressly identified in the Offer or separately approved by the Buyer in writing.

4.6 No Unapproved Substitution
The Buyer shall not be deemed to have accepted an alternative Product merely because the alternative is commercially or technically similar.

5. PRODUCT SOURCE AND MANUFACTURER
5.1 Supplier Sourcing
Euroasiann may source Goods from manufacturers, authorized distributors, independent distributors, stockists, traders, resellers, or other lawful commercial sources.

5.2 Manufacturer
Unless expressly stated otherwise, Euroasiann is not the manufacturer of the Goods.

5.3 Manufacturer Warranty
Where a manufacturer's warranty applies, the scope and availability of that warranty shall depend upon the manufacturer's applicable warranty terms.

5.4 No Manufacturer Representation
Euroasiann shall not be deemed to represent that it is the manufacturer, authorized representative, authorized distributor, or exclusive distributor of a manufacturer unless expressly stated in writing.

5.5 OEM and Aftermarket
The Offer shall identify the Goods as OEM, aftermarket, equivalent, refurbished, used, or another condition where such classification is commercially relevant.

5.6 Product Information
Manufacturer names, trademarks, technical specifications, photographs, catalog information, and other Product information may originate from the manufacturer, Supplier, or other Third Parties.

6. PRICING
6.1 Offer Price
The price payable by the Buyer shall be the price expressly stated in the accepted Offer.

6.2 Currency
The applicable currency shall be the currency expressly stated in the Offer.

6.3 Taxes
Unless expressly stated otherwise, prices exclude applicable taxes, duties, levies, customs charges, withholding taxes, and governmental charges.

6.4 Tax Changes
Where Applicable Law requires additional taxes, duties, levies, or governmental charges after the Offer date, the Buyer shall bear such additional amounts to the extent legally permissible.

6.5 Currency Fluctuation
Where an Offer is expressly subject to currency fluctuation, changes in currency exchange rates between acceptance and payment may result in corresponding price adjustments as stated in the Offer.

6.6 Obvious Pricing Errors
Euroasiann reserves the right to correct obvious typographical, calculation, currency, decimal-point, system, or other manifest pricing errors before the Transaction becomes binding.

If an obvious error is identified after acceptance but before fulfilment, Euroasiann may notify the Buyer and allow the Buyer to accept the corrected price or cancel the affected Transaction.

6.7 No Retroactive Price Change
Except for agreed adjustments, taxes, duties, currency adjustments, or manifest errors expressly permitted under these Sale Terms, Euroasiann shall not arbitrarily increase the agreed price after acceptance.

7. PACKING, HANDLING AND SPECIAL REQUIREMENTS
7.1 Standard Packing
Unless otherwise stated in the Offer, the price includes only the standard commercial packaging ordinarily used by the relevant Supplier for the Goods.

7.2 Special Packing
Any special packaging, seaworthy packing, export packing, wooden case, palletization, fumigation, corrosion protection, moisture protection, shock protection, hazardous-material packaging, or other special handling shall be charged separately unless expressly included in the Offer.

7.3 Packing Requirements
Where the Buyer requests special packing after acceptance of the Offer, Euroasiann may charge the resulting additional costs.

7.4 Packaging Costs
The Buyer shall bear additional packaging costs where those costs are not expressly included in the accepted Offer.

7.5 No Assumption of Packing Liability
Euroasiann shall not be responsible for special packing requirements that were not communicated by the Buyer before acceptance of the Offer.

8. FREIGHT, LOGISTICS AND TRANSPORT
8.1 Delivery Terms
Delivery shall be performed according to the delivery terms expressly stated in the Offer.

8.2 Incoterms
Where Incoterms are used, the applicable Incoterm and named place shall be expressly stated in the Offer.

8.3 Freight
Unless expressly included in the Offer, freight, courier, air freight, sea freight, trucking, forwarding, local transportation, port handling, terminal charges, storage, demurrage, detention, and related logistics costs are excluded.

8.4 Freight Changes
Where freight is expressly quoted based on a Third-Party carrier or logistics provider, subsequent carrier price changes, fuel surcharges, security surcharges, congestion charges, emergency surcharges, or other Third-Party charges may be passed through to the Buyer where the Offer expressly permits such adjustment.

8.5 Carrier Selection
Unless expressly agreed otherwise, Euroasiann may select the carrier, freight forwarder, courier, or logistics provider used to fulfil the Transaction.

8.6 Third-Party Logistics Providers
Euroasiann shall not be responsible for acts or omissions of independent carriers, freight forwarders, customs brokers, port agents, warehouses, terminal operators, couriers, or other logistics providers except to the extent liability cannot lawfully be excluded or where Euroasiann has expressly assumed responsibility for the relevant service.

9. CUSTOMS, IMPORT, EXPORT AND GOVERNMENTAL CHARGES
9.1 Buyer Responsibility
Unless expressly stated otherwise in the Offer, the Buyer shall be responsible for all importation requirements and costs applicable at the destination.

9.2 Customs Duties
Customs duties, import duties, tariffs, customs assessments, customs examination fees, brokerage charges, import taxes, destination taxes, and similar charges shall be borne by the party responsible under the applicable Incoterm or Offer.

9.3 Customs Clearance
Unless expressly included in the Offer, Euroasiann is not responsible for customs clearance at the destination.

9.4 Import Licences
The Buyer shall obtain and maintain all import licences, permits, approvals, registrations, end-user certificates, and other documents required for importation into the destination jurisdiction.

9.5 Export Licences
Where an export licence or governmental approval is required from the country of export, the relevant responsibility shall be allocated according to Applicable Law and the Offer.

9.6 Customs Delays
Euroasiann shall not be responsible for delays, additional costs, seizures, inspections, holds, storage, demurrage, detention, penalties, or other consequences arising from customs authorities, import authorities, export authorities, or governmental agencies, except to the extent caused by Euroasiann's legally attributable breach.

9.7 Incorrect Buyer Information
The Buyer shall be responsible for costs arising from inaccurate or incomplete information supplied by the Buyer for customs, shipping, import, export, consignee, Vessel, or documentation purposes.

9.8 Fines and Penalties
Fines, penalties, duties, assessments, storage charges, demurrage, detention, or other governmental or Third-Party charges caused by the Buyer's acts, omissions, inaccurate information, failure to receive Goods, failure to clear Goods, or failure to provide required documentation shall be borne by the Buyer.

10. VESSEL, PORT AND DELIVERY INFORMATION
10.1 Buyer Information
The Buyer shall provide accurate:

Vessel name;

IMO number;

Port;

Berth, where applicable;

Consignee;

Notify party;

Delivery address;

Contact details;

ETA/ETD information;

and other information necessary for delivery.

10.2 Port Changes
If the Buyer changes the delivery port, Vessel, consignee, delivery address, or other material delivery information after acceptance, Euroasiann may charge all resulting additional costs.

10.3 Vessel Schedule
Euroasiann does not guarantee that Goods will arrive before a Vessel's departure unless a specific delivery commitment has been expressly confirmed in writing.

10.4 Vessel Delay
Costs resulting from Vessel delays, berth changes, port congestion, port closure, missed connection, storage, waiting time, re-routing, or other Vessel or port-related circumstances shall be allocated according to the applicable Offer and Incoterm.

11. DELIVERY DATES
11.1 Estimated Dates
Unless expressly stated as a guaranteed contractual delivery date, delivery dates are estimates.

11.2 Supplier Lead Time
Supplier lead times are estimates unless expressly guaranteed in writing.

11.3 Third-Party Delays
Euroasiann shall not be responsible for delays caused by Suppliers, manufacturers, carriers, freight forwarders, customs authorities, ports, airports, weather, strikes, governmental restrictions, Vessel changes, or other Third Parties beyond Euroasiann's reasonable control.

11.4 Delay Notification
Euroasiann shall use reasonable commercial efforts to communicate material delays of which it becomes aware.

11.5 No Automatic Penalty
No delay penalty, liquidated damages, loss of hire, demurrage, off-hire, Vessel delay claim, charter-party claim, production loss, or other consequential claim shall apply against Euroasiann unless expressly agreed in writing.

12. TITLE AND RISK
12.1 Title
Title to the Goods shall pass in accordance with the applicable Offer, Transaction terms, applicable Incoterm where relevant, and Applicable Law.

12.2 Payment Before Transfer
Where the Offer requires advance or full payment before dispatch, Euroasiann may retain title or control over the Goods until the required payment has been received, to the extent legally permissible.

12.3 Risk
Risk of loss or damage shall transfer in accordance with the agreed delivery term, Incoterm, Transaction terms, and Applicable Law.

12.4 No Double Recovery
The Buyer shall not recover twice for the same loss from Euroasiann, a carrier, an insurer, or another party.

13. INSURANCE
13.1 Transport Insurance
Transport insurance shall be included only where expressly stated in the Offer.

13.2 Buyer Insurance
Where the applicable Incoterm or Transaction places transport risk on the Buyer, the Buyer shall obtain appropriate insurance.

13.3 Insurance Claims
Where transport insurance has been arranged through a Third Party, claims shall be subject to the relevant insurer's terms, exclusions, deductibles, limits, and claims procedures.

13.4 No Unstated Insurance Coverage
Euroasiann shall not be deemed to provide cargo, marine, transport, liability, or other insurance unless expressly stated in the Offer.

14. INSPECTION AND ACCEPTANCE
14.1 Examination
The Buyer shall inspect the Goods within a reasonable period following delivery.

14.2 Visible Damage
Visible transport damage should be documented on the carrier's delivery receipt or transport documentation at the time of delivery where reasonably possible.

14.3 Quantity
The Buyer shall promptly verify quantities against the applicable delivery documentation.

14.4 Concealed Defects
Claims concerning latent or concealed defects shall be notified within the applicable warranty or statutory period.

14.5 Notice of Non-Conformity
The Buyer shall provide Euroasiann with reasonable details and supporting evidence concerning any alleged non-conformity.

14.6 Failure to Notify
Subject to mandatory Applicable Law, failure to provide timely notice may affect the Buyer's ability to pursue a claim where the delay materially prejudices Euroasiann's ability to investigate or resolve the matter.

15. RETURNS AND REPLACEMENTS
15.1 No Unilateral Returns
Goods may not be returned without prior written authorization from Euroasiann.

15.2 Return Authorization
Euroasiann may issue a Return Material Authorization or equivalent return instruction where a return is approved.

15.3 Buyer-Caused Returns
Returns arising from incorrect Buyer specifications, incorrect Part Numbers, change of mind, Vessel schedule changes, duplicate orders, incorrect quantities, or other Buyer-caused circumstances may be accepted only at Euroasiann's discretion and may be subject to restocking, freight, handling, Supplier, and other charges.

15.4 Customized or Special-Order Goods
Customized, non-standard, specially procured, specially manufactured, non-cancellable, or Supplier-specific Goods may be non-returnable where expressly stated in the Offer.

15.5 Return Freight
Return freight and associated costs shall be borne by the party responsible for the return, subject to Applicable Law and the applicable Transaction.

16. WARRANTY
16.1 Applicable Warranty
Any warranty applicable to the Goods shall be the warranty expressly stated in the Offer or otherwise legally applicable to the Transaction.

16.2 Manufacturer Warranty
Where the Goods are covered by a manufacturer's warranty, Euroasiann may facilitate or coordinate the Buyer's warranty claim with the Supplier or manufacturer where commercially appropriate.

16.3 No Expanded Warranty
Euroasiann shall not be deemed to provide a warranty broader than the warranty expressly stated in the Offer or required by mandatory Applicable Law.

16.4 Warranty Exclusions
Subject to mandatory Applicable Law, warranty coverage may not apply to:

improper installation;

improper storage;

misuse;

abnormal operating conditions;

unauthorized modification;

improper maintenance;

wear and tear;

corrosion;

contamination;

accident;

negligence;

incorrect installation;

use outside specifications;

or other causes unrelated to a defect attributable to the Goods.

16.5 Warranty Remedy
Where a valid warranty claim is established, the applicable remedy shall be determined according to the Offer, manufacturer warranty, Supplier warranty, replacement arrangement, repair arrangement, refund arrangement, or Applicable Law.

17. PRODUCT LIABILITY AND TECHNICAL RESPONSIBILITY
17.1 Product Use
The Buyer remains responsible for the proper installation, operation, maintenance, inspection, and use of the Goods.

17.2 Technical Suitability
Unless expressly contracted to provide engineering or technical consulting services, Euroasiann does not warrant that Goods are suitable for a particular Vessel, machinery system, application, operating condition, or regulatory requirement beyond the express specifications stated in the accepted Offer.

17.3 Professional Verification
The Buyer shall obtain appropriate technical verification from its engineers, superintendent, classification society, manufacturer, consultant, or other competent professional where necessary.

17.4 Safety-Critical Goods
For safety-critical, class-critical, navigation, propulsion, steering, electrical, pressure, lifting, fire-fighting, life-saving, or other safety-sensitive Goods, the Buyer remains responsible for confirming suitability and regulatory compliance before installation or use unless Euroasiann has expressly undertaken such verification in writing.

18. DOCUMENTATION
18.1 Documents Included
Only documents expressly identified in the Offer are included in the sale.

18.2 Additional Documents
Additional certificates, inspection reports, test certificates, manufacturer certificates, class documents, legalization, notarization, consularization, or other special documentation shall be provided only where expressly included or separately agreed.

18.3 Documentation Charges
Any special documentation costs shall be borne by the Buyer where not included in the Offer.

18.4 Third-Party Documents
Euroasiann may rely on documents supplied by manufacturers, Suppliers, inspection companies, laboratories, carriers, or other Third Parties.

19. CUSTOMS AND SHIPPING DOCUMENTATION
The Buyer is responsible for reviewing all shipping and commercial documentation supplied for the Transaction and promptly notifying Euroasiann of any material discrepancy.

Euroasiann shall not be responsible for delays or costs resulting from inaccurate information supplied by the Buyer or from actions of customs authorities, carriers, ports, freight forwarders, or other independent Third Parties, except to the extent liability cannot lawfully be excluded.

20. PAYMENT
20.1 Payment Terms
Payment shall be made according to the payment terms stated in the Offer.

20.2 Advance Payment
Where advance payment is required, Euroasiann shall have no obligation to procure or dispatch the Goods until the required payment has been received and cleared.

20.3 Payment Delays
If the Buyer fails to pay when due, Euroasiann may suspend procurement, delivery, release, or further performance.

20.4 Bank Charges
Unless expressly stated otherwise, bank charges imposed by the Buyer's bank, intermediary banks, payment providers, or receiving banks shall be borne by the Buyer.

20.5 Withholding
The Buyer shall not withhold or deduct payments unless legally required.

20.6 Set-Off
The Buyer shall not set off or deduct disputed claims against amounts due to Euroasiann unless expressly agreed or permitted by mandatory Applicable Law.

20.7 Late Payment
Late payments may result in interest, collection costs, suspension of further Transactions, and other remedies to the extent permitted by Applicable Law.

21. CANCELLATION
21.1 Before Supplier Commitment
A cancellation request received before Euroasiann has committed to procure the Goods may be considered by Euroasiann at its discretion.

21.2 After Supplier Commitment
Once Euroasiann has placed a binding order with a Supplier, cancellation shall be subject to the Supplier's cancellation terms and any costs incurred.

21.3 Non-Cancellable Goods
Goods identified as non-cancellable, non-returnable, specially manufactured, specially procured, or Supplier-specific cannot be cancelled except with the written agreement of Euroasiann and subject to all resulting costs.

21.4 Cancellation Costs
The Buyer shall reimburse reasonable and legally recoverable costs arising from an authorized cancellation where such costs were incurred specifically for the Buyer's Transaction.

22. FORCE MAJEURE AND EXTERNAL EVENTS
Euroasiann shall not be liable for failure or delay caused by events beyond its reasonable control, including:

war;

terrorism;

sanctions;

embargoes;

governmental restrictions;

customs restrictions;

port closures;

strikes;

labour disputes;

natural disasters;

fire;

flood;

epidemic or pandemic;

cyber incidents affecting Third Parties;

carrier failure;

Supplier failure;

manufacturer failure;

raw material shortages;

transport disruption;

Vessel changes;

infrastructure failure;

or other comparable events.

Where such circumstances occur, Euroasiann may suspend, delay, modify, or cancel affected performance to the extent permitted by Applicable Law.

23. THIRD-PARTY CHARGES
23.1 Pass-Through Costs
Unless expressly included in the Offer, all Third-Party costs incurred specifically for the Transaction may be charged to the Buyer where commercially and legally applicable.

23.2 Examples
Such costs may include:

freight;

courier;

customs;

duties;

taxes;

port charges;

terminal charges;

storage;

demurrage;

detention;

documentation;

inspection;

certification;

special packing;

handling;

insurance;

bank charges;

currency costs;

government fees;

regulatory charges;

re-routing;

return freight;

disposal;

and other Transaction-specific costs.

23.3 Government Charges
Governmental charges imposed after acceptance of the Offer shall be borne by the party legally responsible for such charges and, where legally permissible, may be passed through to the Buyer where attributable to the Buyer's Transaction.

24. NO RESPONSIBILITY FOR BUYER'S DOWNSTREAM LOSSES
To the maximum extent permitted by Applicable Law, Euroasiann shall not be liable for:

Vessel delay;

off-hire;

loss of charter revenue;

loss of freight revenue;

loss of production;

loss of business;

loss of contracts;

loss of anticipated savings;

loss of opportunity;

loss of goodwill;

consequential loss;

indirect loss;

special damages;

punitive damages;

or other remote or consequential losses

arising from or relating to the Goods, delivery, delay, customs, logistics, Supplier performance, manufacturer performance, or Third-Party services.

25. LIMITATION OF LIABILITY
25.1 Maximum Liability
To the maximum extent permitted by Applicable Law, Euroasiann's aggregate liability arising from a Transaction shall not exceed the net amount actually paid to Euroasiann by the Buyer for the specific Goods giving rise to the claim.

25.2 No Liability Beyond Transaction Value
Euroasiann shall not be liable for amounts exceeding the value of the affected Transaction except where such limitation is prohibited by Applicable Law.

25.3 Excluded Damages
To the maximum extent permitted by Applicable Law, Euroasiann shall not be liable for indirect, incidental, special, exemplary, punitive, or consequential damages.

25.4 Mandatory Liability
Nothing in these Sale Terms excludes or limits liability that cannot legally be excluded or limited.

25.5 Fraud and Wilful Misconduct
Nothing in these Sale Terms excludes liability for fraud, fraudulent misrepresentation, or other liability that cannot lawfully be excluded.

26. BUYER INDEMNIFICATION
The Buyer shall indemnify and hold harmless Euroasiann, its Affiliates, officers, directors, employees, representatives, and service providers against claims, losses, costs, penalties, damages, and reasonable expenses arising from:

inaccurate Buyer information;

unlawful importation;

incorrect customs declarations;

incorrect Vessel or consignee information;

unauthorized use of the Goods;

improper installation;

improper operation;

modification of Goods;

violation of Applicable Law by the Buyer;

sanctions or export-control violations attributable to the Buyer;

misuse of Goods;

Buyer-provided technical specifications;

Buyer-provided documentation;

or other matters attributable to the Buyer's acts or omissions,

to the maximum extent permitted by Applicable Law.

27. THIRD-PARTY MANUFACTURERS, SUPPLIERS AND SERVICE PROVIDERS
27.1 Independent Third Parties
Suppliers, manufacturers, carriers, freight forwarders, customs brokers, inspectors, laboratories, warehouses, port agents, and other service providers are independent Third Parties.

27.2 No Assumption of Third-Party Obligations
Euroasiann does not assume responsibility for independent Third-Party obligations except to the extent expressly agreed or required by mandatory Applicable Law.

27.3 Supplier Claims
Where a claim arises from a Supplier's or manufacturer's independent obligation, Euroasiann may pursue or facilitate recovery from the relevant Supplier or manufacturer where commercially appropriate.

27.4 No Direct Liability Assumption
Euroasiann's involvement in coordinating a Third-Party claim does not constitute an admission that Euroasiann is legally responsible for the underlying event.

28. COMPLIANCE
The Buyer shall comply with all Applicable Laws relating to the purchase, importation, exportation, transportation, installation, possession, use, resale, and disposal of the Goods.

This includes, where applicable:

sanctions;

export controls;

import controls;

customs;

anti-bribery;

tax;

environmental;

safety;

maritime;

product;

and end-use requirements.

29. END USE AND VESSEL INFORMATION
The Buyer shall provide accurate information concerning the intended Vessel, end user, destination, end use, consignee, and other information reasonably required for compliance screening.

Euroasiann may refuse, suspend, or cancel a Transaction where it reasonably determines that completing the Transaction could create a legal, sanctions, export-control, regulatory, safety, or material commercial risk.

30. SUSPENSION AND CANCELLATION BY EUROASIANN
Euroasiann may suspend, cancel, or refuse to fulfil an Offer or Transaction where:

payment is not received;

the Supplier cannot supply the Goods;

the Goods become unavailable;

the Supplier materially changes its terms;

required approvals cannot be obtained;

sanctions or export restrictions apply;

customs restrictions apply;

the transaction becomes unlawful;

material information supplied by the Buyer is inaccurate;

the Buyer fails to provide required documents;

a material security or fraud concern arises;

or another circumstance materially prevents lawful or commercially reasonable fulfilment.

Where Euroasiann cancels a Transaction solely because the Transaction cannot lawfully or reasonably be fulfilled and the Buyer has already paid, Euroasiann's refund obligation shall be limited to amounts actually received by Euroasiann for the affected Goods, subject to Applicable Law and any non-refundable Third-Party costs expressly agreed to by the Buyer.

31. REFUNDS
31.1 Refund Method
Where a refund is due, Euroasiann may refund the amount through the original payment method or another mutually agreed method.

31.2 Third-Party Charges
Where legally permissible, non-refundable bank charges, payment processing charges, customs charges, special procurement costs, or other Third-Party costs may be deducted where those costs were expressly disclosed or agreed.

31.3 Refund Timing
Refunds shall be processed within a commercially reasonable period after Euroasiann determines that a refund is due and all required information has been received.

32. NO WARRANTY BEYOND EXPRESS TERMS
Except for warranties that cannot lawfully be excluded, Euroasiann provides only the warranties expressly stated in the Offer, applicable Transaction, or mandatory Applicable Law.

No employee, representative, Supplier, salesperson, Platform user, or other person is authorized to create an additional warranty on behalf of Euroasiann unless expressly authorized in writing.

33. ENTIRE TRANSACTION
The accepted Offer, these Sale Terms, applicable specifications, agreed Purchase Order, and expressly incorporated documents constitute the complete contractual framework for the relevant sale.

Any Buyer purchase-order terms that conflict with these Sale Terms shall not apply unless expressly accepted by Euroasiann in writing.

34. BUYER PURCHASE ORDER TERMS
The issuance of a Buyer Purchase Order does not automatically incorporate the Buyer's standard purchasing terms.

Buyer terms shall apply only where expressly accepted in writing by an authorized Euroasiann representative.

35. ORDER OF PRECEDENCE
Unless expressly agreed otherwise, the following order shall apply in the event of inconsistency:

Mandatory Applicable Law;

A separately signed Transaction-specific Contract;

The accepted Euroasiann Offer;

These Sale Terms;

The Buyer's Purchase Order, only to the extent expressly accepted by Euroasiann;

Other documents incorporated by reference.

36. ELECTRONIC ACCEPTANCE
The Buyer agrees that electronic acceptance of the Offer and these Sale Terms is legally binding to the maximum extent permitted by Applicable Law.

The Buyer acknowledges that electronic records may be retained as evidence of acceptance.

The Buyer represents that the person accepting the Offer has authority to bind the Buyer.

37. CONFIDENTIALITY
Commercial prices, Supplier information, procurement information, technical information, discounts, margins, sourcing information, and other confidential information exchanged in connection with the Transaction shall be treated confidentially except where disclosure is required by Applicable Law or reasonably necessary to perform the Transaction.

38. ASSIGNMENT
The Buyer shall not assign or transfer its rights or obligations under the Transaction without Euroasiann's prior written consent, except where such restriction is prohibited by Applicable Law.

Euroasiann may assign or transfer its rights and obligations to an Affiliate, successor, purchaser, or other lawful transferee in connection with a corporate restructuring, sale, merger, acquisition, or transfer of business.

39. NO AGENCY
Nothing in these Sale Terms creates a partnership, joint venture, employment relationship, fiduciary relationship, or agency relationship between Euroasiann and the Buyer.

40. SEVERABILITY
If any provision of these Sale Terms is found invalid, unlawful, or unenforceable, the remaining provisions shall continue in effect to the maximum extent permitted by Applicable Law.

41. NO WAIVER
Failure by Euroasiann to enforce a provision immediately shall not constitute a waiver of that provision or any other right.

42. GOVERNING LAW AND DISPUTES
The governing law and dispute-resolution mechanism applicable to the Transaction shall be the law and dispute-resolution framework expressly stated in the Offer or the applicable Euroasiann contractual framework.

Where no Transaction-specific governing law is stated, the default governing law and jurisdiction specified by Euroasiann's applicable commercial terms shall apply, subject always to mandatory Applicable Law.

43. LANGUAGE
Unless otherwise agreed, the English-language version of the Offer and these Sale Terms shall be the controlling contractual version.

44. SURVIVAL
Provisions concerning payment, liability, indemnification, confidentiality, Intellectual Property, disputes, warranties, returns, recordkeeping, and other obligations that by their nature are intended to survive completion or termination shall remain effective after completion or termination of the Transaction.

45. NO IMPLIED EXPANSION OF EUROASIANN'S LIABILITY
The Buyer acknowledges that Euroasiann's commercial role is limited to the obligations expressly assumed in the accepted Offer, Transaction, and these Sale Terms.

Euroasiann shall not be deemed to assume responsibility for any obligation merely because Euroasiann:

introduced a Supplier;

arranged procurement;

coordinated delivery;

provided tracking information;

communicated with a carrier;

provided Product information;

arranged documentation;

facilitated customs communication;

coordinated inspection;

processed payment;

or provided customer support.

46. BUYER'S ACCEPTANCE OF COMMERCIAL RISK
The Buyer acknowledges that marine procurement may involve international Suppliers, multiple jurisdictions, changing Vessel schedules, customs requirements, transport providers, port conditions, manufacturer lead times, and other external factors.

The Buyer agrees to bear the risks and costs allocated to it under the Offer, these Sale Terms, the applicable Incoterm, and Applicable Law.

47. NO GUARANTEE OF VESSEL OPERATION
Euroasiann does not guarantee that the Goods will prevent or resolve Vessel downtime, off-hire, delays, machinery failures, port delays, class issues, charter-party consequences, or operational losses.

48. NO GUARANTEE OF THIRD-PARTY PERFORMANCE
Euroasiann does not guarantee the continued performance, financial condition, availability, solvency, delivery capability, or operational performance of any independent Supplier, manufacturer, carrier, freight forwarder, customs broker, inspection company, warehouse, port agent, or other Third Party.

49. LIMITATION OF CLAIMS
Any claim arising from the Transaction shall be made promptly after the Buyer becomes aware, or should reasonably have become aware, of the circumstances giving rise to the claim, subject to mandatory Applicable Law.

50. NO DOUBLE RECOVERY
The Buyer shall not recover the same loss more than once from Euroasiann, a Supplier, manufacturer, carrier, insurer, or any other party.

51. FINAL COMMERCIAL ACCEPTANCE
By clicking "Accept Offer & Terms", the Buyer confirms:

it has reviewed the Offer;

it has reviewed these Sale Terms;

it accepts the stated price;

it accepts the stated delivery conditions;

it accepts the stated payment terms;

it accepts the allocation of freight, customs, taxes, packing, insurance, and other charges;

it confirms the accuracy of the information it has provided;

it confirms the authority of the accepting person;

and it agrees that the Transaction shall be governed by the Offer and these Sale Terms.

CLICKING "ACCEPT OFFER & TERMS" CONSTITUTES ELECTRONIC ACCEPTANCE OF THE OFFER AND THESE SALE TERMS.`;
